import { render, staticRenderFns } from "./Broker.vue?vue&type=template&id=2814c704&scoped=true&"
import script from "./Broker.vue?vue&type=script&lang=js&"
export * from "./Broker.vue?vue&type=script&lang=js&"
import style0 from "./Broker.vue?vue&type=style&index=0&id=2814c704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2814c704",
  null
  
)

export default component.exports